<template>
  <!--
      	作者：gmshop
      	时间：2020-06-01
      	描述：插件中心-分销-提现申请
      -->
  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="审核状态">
          <el-select v-model="formInline.apply_status" placeholder="请选择" style="width:120px">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待审核" value="10"></el-option>
            <el-option label="审核通过" value="20"></el-option>
            <el-option label="已打款" value="40"></el-option>
            <el-option label="驳回" value="30"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="提现方式">
          <el-select v-model="formInline.pay_type" placeholder="请选择" style="width:120px">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="微信" value="10"></el-option>
            <el-option label="支付宝" value="20"></el-option>
            <el-option label="银行卡" value="30"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="用户id">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID" style="width:120px"></el-input>
        </el-form-item>
        <el-form-item label=""><el-input v-model="formInline.search" placeholder="请输入昵称/姓名/手机号"></el-input></el-form-item>
        <el-form-item label="申请时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item><el-button type="success" @click="onExport" >导出</el-button></el-form-item>
      </el-form>
    </div>

    <!--批量操作-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="batchSubmit" icon="el-icon-document-checked" v-auth="'/plus/agent/cash/batch_submit'">批量审核</el-button>
      <el-button size="small" type="primary" @click="batchMoney" icon="el-icon-document-checked" v-auth="'/plus/agent/cash/batch_money'">批量已打款</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="user_id" label="用户ID" width="60" sortable="custom"></el-table-column>
         <!-- <el-table-column prop="nickName" label="微信头像" width="70">
            <template slot-scope="scope">
              <img class="radius" v-img-url="scope.row.avatarUrl" width="30" height="30" />
            </template>
          </el-table-column> -->
          <el-table-column prop="nickName" label="用户信息" width="100">
            <template slot-scope="scope">
              <p class="text-ellipsis" :title="scope.row.nickName">{{ scope.row.nickName }}</p>
              <p class="text-ellipsis" :title="scope.row.mobile">{{ scope.row.mobile }}</p>
              <p class="text-ellipsis">{{ scope.row.user.grade.name }}</p>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="user.grade.name" label="等级" width="100" align="center"></el-table-column> -->


          <el-table-column prop="ac_type" label="业务类型">
            <template slot-scope="scope">
              <span v-if="scope.row.ac_type=='oneself'">自购收益</span>
              <span v-if="scope.row.ac_type=='share'">分享收益</span>
              <span v-if="scope.row.ac_type=='training_cultivate_sys'">系统收益</span>
              <span v-if="scope.row.ac_type=='cityopt'">运营收益</span>
            </template>
          </el-table-column>

          <el-table-column prop="money" label="提现金额" sortable="custom">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="real_money" label="实际到账">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.real_money }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="total_fee" label="手续费">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.total_fee }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="提现方式"></el-table-column>
          <el-table-column prop="pay_type" label="提现信息" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.pay_type.value == 20">
                <p>
                  <span>{{ scope.row.alipay_name }}</span>
                </p>
                <p>
                  <span>{{ scope.row.alipay_account }}</span>
                </p>
              </div>
              <div v-else-if="scope.row.pay_type.value == 30">

              <!--  <p>
                  <span>{{ scope.row.bank_name }}</span>
                </p>
                <p>
                  <span>{{ scope.row.bank_account }}</span>
                </p>
                <p>
                  <span>{{ scope.row.bank_card }}</span>
                </p> -->

                <p v-if="scope.row.realname">
                  姓名:<span>{{ scope.row.realname }}</span><br/>
                  手机号:<span>{{ scope.row.bank_mobile }}</span><br/>
                  身份证号:<span>{{ scope.row.bank_idcard }}</span><br/>
                  银行卡号:<span>{{ scope.row.bank_no }}</span><br/>
                  开户银行:<span>{{ scope.row.bank_name }}</span><br/>
                  备注:<span>{{ scope.row.bnote }}</span><br/>
                </p>

              </div>
              <div v-else>
                <p><span>--</span></p>
              </div>





            </template>
          </el-table-column>
          <el-table-column prop="apply_status.text" label="审核状态"></el-table-column>
          <el-table-column prop="transfer_status" label="单据状态"></el-table-column>
          <el-table-column prop="create_time" label="申请时间" width="135" sortable="custom"></el-table-column>
          <el-table-column prop="audit_time" label="审核时间" width="135" sortable="custom"></el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <div v-if="scope.row.apply_status.value == 10 || scope.row.apply_status.value == 20">
                <el-button @click="editClick(scope.row)" type="text" size="small" v-if="scope.row.pay_status ==0" v-auth="'/plus/agent/cash/submit'">审核</el-button>
                <template v-if="scope.row.apply_status.value == 20 && scope.row.pay_status ==0">
                  <el-button @click="makeMoney(scope.row)" type="text" size="small" v-auth="'/plus/agent/cash/money'">确认打款</el-button>
                </template>
                <template v-if="scope.row.apply_status.value == 20 && scope.row.pay_type.value == 10 && scope.row.pay_status ==0">
                  <el-button @click="addClick(scope.row.id)" type="text" size="small" v-auth="'/plus/agent/cash/money'">微信付款</el-button>
                </template>
                <template v-if="scope.row.apply_status.value == 20 && scope.row.pay_type.value == 10 && scope.row.pay_status ==10 && scope.row.state_text==''">
                  <el-button @click="PayStatus(scope.row)" type="text" size="small" v-auth="'/plus/agent/cash/money'">查看商家转账信息</el-button>
                </template>
                <template v-if="scope.row.apply_status.value == 20 && scope.row.pay_type.value == 10 && scope.row.pay_status ==10 && scope.row.state_text!=''">
                  <el-button @click="refreshStatus(scope.row)" type="text" size="small" v-auth="'/plus/agent/cash/money'">更新状态</el-button>
                </template>
                <template v-if="scope.row.apply_status.value == 20 && scope.row.pay_type.value == 10 && scope.row.pay_status ==10 && scope.row.state_text=='WAIT_USER_CONFIRM'">
                  <el-button @click="cancelTranfer(scope.row)" type="text" size="small" v-auth="'/plus/agent/cash/money'">撤销转账</el-button>
                </template>
              </div>
              <div v-if="scope.row.apply_status.value == 30">
                <el-button @click="editClick(scope.row)" type="text" size="small">查看详情</el-button>
               </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
    <WxPay v-if="open_wxpay" :open_wxpay="open_wxpay" :id="userModel" @closeDialog="closeDialogFunc($event, 'wxpay')"></WxPay>
    <Status v-if="open_status" :open_status="open_status" :form="userModel" @closeDialog="closeDialogFunc($event, 'pay_status')"></Status>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';
import Edit from './dialog/Edit.vue';
import WxPay from './dialog/WxPay.vue';
import Status from './dialog/Paystatus.vue';
import qs from 'qs';
export default {
  components: {
    /*编辑组件*/
    Edit,
    WxPay,
    Status
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      formInline: {
        search: '',
        /*用户ID*/
        user_id: '',
        reg_date:''
      },
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*是否打开微信付款*/
      open_wxpay: false,
      /*是否打开商家转账*/
      open_status:false,
      /*当前编辑的对象*/
      userModel: {},
      /*选择ids*/
      selected: {}
    };
  },
  props: {},
  watch:{

    $route(to, from) {
      if (to.query.user_id != null) {
        this.formInline.user_id = to.query.user_id;
      }else{
        this.formInline.user_id ='';
      }
      this.curPage = 1;
      this.getData();
    }

  },
  created() {
    if (this.$route.query.user_id != null) {
      this.formInline.user_id = this.$route.query.user_id;
    }
    /*获取列表*/
    this.getData();
  },
  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.sort_name = self.sortName;
      Params.sort_value = self.sortValue;
      PlusApi.cash(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索*/
    onSubmit() {
      let self = this;
      self.page=1;
      self.loading = true;
      let Params = self.formInline;
      PlusApi.cash(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*排序查询*/
    sortChange(e){
      if (e.order && e.order != null){
        this.sortName = e.prop;
        this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
      }else{
        this.sortName = this.sortValue = '';
      }
      this.tableData = [];
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*打开弹出层编辑*/
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },

    /*打开弹出层编辑*/
    addClick(item) {
      this.userModel = item;
      this.open_wxpay = true;
    },
    /*打开弹出层商家转账*/
    PayStatus(item) {
      this.userModel = item;
      this.open_status = true;
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
      if (f == 'wxpay') {
        this.open_wxpay = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
      if (f == 'pay_status') {
          this.open_status = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
      }
    },
    /*导出数据*/
    onExport() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/plus.agent.cash/export?' + qs.stringify(this.formInline);
    },

    /*确认打款*/
    makeMoney(e) {
      let self = this;
      self
        .$confirm('确认要打款吗?确认之后需要手动转账给用户。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          PlusApi.money(
            {
              id: e.id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，操作成功',
                  type: 'success'
                });
                self.getData();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },
    /*更新状态*/
    refreshStatus(e) {
      let self = this;
      self
        .$confirm('更新最新状态?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          PlusApi.transfersDetail(
            {
              id: e.id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，操作成功',
                  type: 'success'
                });
                self.getData();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },
    // 撤销转账
    cancelTranfer(e) {
      let self = this;
      self
        .$confirm('确定撤销转账吗，操作不可撤销?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          PlusApi.transfersDetail(
            {
              id: e.id,
              is_cancel:1,
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，操作成功',
                  type: 'success'
                });
                self.getData();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },

    // /*微信打款*/
    // WxPay(e) {
    //   let self = this;
    //   self
    //     .$confirm('该操作 将使用微信支付企业付款到零钱功能，确定打款吗？', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     })
    //     .then(() => {
    //       self.loading = true;
    //       PlusApi.WxPay(
    //         {
    //           id: e
    //         },
    //         true
    //       )
    //         .then(data => {
    //           self.loading = false;
    //           if (data.code == 1) {
    //             self.$message({
    //               message: '恭喜你，操作成功',
    //               type: 'success'
    //             });
    //             this.getData();
    //           } else {
    //             self.loading = false;
    //           }
    //         })
    //         .catch(error => {
    //           self.loading = false;
    //         });
    //     })
    //     .catch(() => {});
    // },
    /*批量选择*/
    handleSelectionChange(val) {
      this.selected = val;
    },
    /*取选中*/
    getSelectedIds(arr){
      let ids = [];
      for (const i in arr) {
        if (arr.hasOwnProperty(i)) {
          ids.push(arr[i].id);
        }
      }
      return ids;
    },

    /*批量审核*/
    batchSubmit() {
      let self = this;
      if (!self.selected.length){
        self.$message({
          message: '请选择操作的记录',
          type: 'warning'
        });
        return;
      }
      self
        .$confirm('确认已审核吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          let params = {ids:self.getSelectedIds(self.selected)};
          PlusApi.cashBatchSubmit(params, true)
            .then(data => {
              self.$message({
                message: data.msg,
                type: data.code == 1 ? 'success' : 'error'
              });
              self.getData();
              self.dialogFormVisible(true);
            })
            .catch(error => {});
        })
        .catch(() => {});
    },

    /*批量确认打款*/
    batchMoney() {
      let self = this;
      if (!self.selected.length){
        self.$message({
          message: '请选择操作的记录',
          type: 'warning'
        });
        return;
      }
      self
        .$confirm('确认已打款吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          let params = {ids:self.getSelectedIds(self.selected)};
          PlusApi.batchMoney(params, true)
            .then(data => {
              self.$message({
                message: data.msg,
                type: data.code == 1 ? 'success' : 'error'
              });
              self.getData();
              self.dialogFormVisible(true);
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/agent/cash/Cash.vue